export default "__VITE_ASSET__BG87zLTf__"